module.exports = __webpack_public_path__ + "static/media/7x7BadOptimized.0c144580.png";